export class User {
    firstName:string;
    lastName:string;
    email:string;
    roles:Array<string>;
    canal:string;
    activated:boolean;
    id:string;
    language:string;

    constructor(user:any) {
        this.id = user.id;
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.email = user.email;
        this.roles = user.roles;
        this.canal = user.canal;
        this.language = user.language;
        this.activated = user.activated;
    }

    isAdmin():boolean {
        return this.roles.indexOf("ROLE_ADMIN") !== -1;
    }
}